import { cn } from "@/shared/lib";

export type SliderMark = {
  label: string;
  value: number;
  text: string;
  tone: "good" | "accent" | "neutral";
};

const TONE = {
  good: "bg-good",
  accent: "bg-accent",
  neutral: "bg-muted",
} as const;

type SliderMarksProps = { min: number; max: number; marks: SliderMark[] };

// Шкала после ответа: верный ответ, твой ответ и значения из матча — отметками на шкале
// и строками легенды под ней.
export const SliderMarks = ({ min, max, marks }: SliderMarksProps) => {
  const position = (value: number) =>
    max > min ? Math.min(100, Math.max(0, ((value - min) / (max - min)) * 100)) : 0;
  return (
    <div className="flex flex-col gap-3">
      <div aria-hidden="true" className="relative mx-2 h-6">
        <span className="absolute inset-x-0 top-2 h-2 rounded-full bg-border" />
        {marks.map((mark) => (
          <span
            key={mark.label}
            className={cn("absolute top-0 h-6 w-1 -translate-x-1/2 rounded-full", TONE[mark.tone])}
            style={{ left: `${position(mark.value)}%` }}
          />
        ))}
      </div>
      <dl className="flex flex-wrap gap-x-6 gap-y-1.5 text-sm">
        {marks.map((mark) => (
          <div key={mark.label} className="flex items-center gap-2">
            <span aria-hidden="true" className={cn("size-2.5 rounded-full", TONE[mark.tone])} />
            <dt className="text-muted">{mark.label}</dt>
            <dd className="font-mono font-semibold">{mark.text}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
};
